import Helper from "./Helper";

class RealVh {
  constructor(config = {}) {
   this.bindEvents();
  }

  bindEvents() {
    window.addEventListener("orientationchange", () => {
      this.setRealVh();
    });

    window.addEventListener("load", () => {
      this.setRealVh();
    });
  }

  setRealVh() {
    let value = "100vh"
    if (Helper.isTablet() === true) {
      const header = document.querySelector('.header');
      let headerHeight = header.offsetHeight;
      let contentHeight = window.innerHeight - headerHeight + 1;
      value = `${contentHeight}px`
      document.documentElement.style.setProperty("--real100vh", value)
    }
  }
}

export default RealVh;
